import styled, { css } from 'styled-components';
import { media } from '@app/styles/themes/constants';
import { BaseLayout } from '@app/components/common/BaseLayout/BaseLayout';

interface isToggle {
  $isToggled: boolean;
}

export const LayoutMaster = styled(BaseLayout)`
  height: 100vh;
`;

export const LayoutMain = styled(BaseLayout)<isToggle>`
  @media only screen and ${media.md} {
    ${(props) =>
      !props?.$isToggled
        ? css`
            margin-left: 240px;
            transition: all 0.2s ease;
          `
        : css`
            margin-left: 80px;
            transition: all 0.2s ease;
          `}
  }

  @media only screen and ${media.xl} {
    ${(props) =>
      !props?.$isToggled
        ? css`
            margin-left: 240px;
            transition: all 0.2s ease;
          `
        : css`
            margin-left: 80px;
            transition: all 0.2s ease;
          `}
  }

  @media only screen and ${media.xxl} {
    ${(props) =>
      !props?.$isToggled
        ? css`
            margin-left: 240px;
            transition: all 0.2s ease;
          `
        : css`
            margin-left: 80px;
            transition: all 0.2s ease;
          `}
  }
`;
